





































import { Component, Prop, Inject, Mixins } from "vue-property-decorator";
import { ISegment } from "@/models/segments";
import AdminBrandId from "@/mixins/adminBrandId";
import { Location as VueLocation } from "vue-router";
import {
  ISegmentsProviderData,
  ISegmentsProviderMethods
} from "@/models/providers/segments";

@Component
export default class SegmentsListView extends Mixins(AdminBrandId) {
  // Inject
  @Inject({ from: "segmentsProviderData" })
  public segmentsProviderData!: () => ISegmentsProviderData;

  @Inject({ from: "segmentsProviderMethods" })
  public $segmentsMethods!: ISegmentsProviderMethods;

  // Prop

  @Prop({ required: true })
  public redirectTo!: (segment: ISegment) => any;

  @Prop({ required: true })
  public redirectAtEmptyRoute!: VueLocation;

  public get $segmentsData() {
    return this.segmentsProviderData();
  }

  public get segmentRoutes() {
    return this.$_.map(this.$segmentsData.segments, segment => {
      return {
        to: this.$router.resolve(this.redirectTo(segment)).route,
        label: segment.name,
        _id: segment.id
      };
    });
  }

  public get activeSegment() {
    const segmentId = this.$_.get(this.$route, "params.segmentId", "");
    return this.$segmentsData.segments?.find(i => i.id === segmentId);
  }

  // Methods

  public deleteSegment(segmentId: ISegment["id"]) {
    this.$segmentsMethods.deleteSegment(segmentId).then(() => {
      const firstRoute = this.segmentRoutes?.[0];
      this.$router.push(
        (firstRoute?.to || this.redirectAtEmptyRoute) as VueLocation
      );
    });
  }
}
